import { useIntl } from "react-intl";
import SVG from "react-inlinesvg";
import { useFindAiTitleAndPlanTotal } from "src/app/hooks";
import { toAbsoluteUrl } from "src/app/utils/AssetHelpers";
import React from "react";
import { useAuth } from "src/app/utils/useAuth";

const TotalAIOrderNeededContainer = () => {
    const { formatMessage } = useIntl();
    const { currentUser } = useAuth();
    const { totalAiTitleAndPlan } = useFindAiTitleAndPlanTotal();
    return (
        <>
            {totalAiTitleAndPlan ? (
                <div className="flex flex-column">
                    {totalAiTitleAndPlan.map(
                        (titleAndPlan, index) =>
                            (titleAndPlan.titles > 0 || titleAndPlan.plans > 0) && (
                                <div className="totalAiTitleText" key={index}>
                                    <a href="/content/stock?commentForWriter%5BfilterModels%5D%5B0%5D%5BfilterType%5D=text&commentForWriter%5BfilterModels%5D%5B0%5D%5Btype%5D=blank&commentForWriter%5BfilterModels%5D%5B1%5D=&writingType%5BfilterModels%5D%5B0%5D%5BfilterType%5D=text&writingType%5BfilterModels%5D%5B0%5D%5Btype%5D=contains&writingType%5BfilterModels%5D%5B0%5D%5Bfilter%5D=auto&writingType%5BfilterModels%5D%5B1%5D=">
                                        <SVG
                                            className="pulse-animation"
                                            src={toAbsoluteUrl(
                                                "/media/icons/duotune/general/gen044.svg"
                                            )}
                                        />
                                        {formatMessage(
                                            { id: "dashboard.AiTitleAndPlan" },
                                            {
                                                titles: titleAndPlan.titles,
                                                plans: titleAndPlan.plans,
                                                user: titleAndPlan.user.includes(currentUser.name)
                                                    ? formatMessage({ id: "dashboard.button.you" })
                                                    : titleAndPlan.user,
                                                has: titleAndPlan.user.includes(currentUser.name)
                                                    ? formatMessage({ id: "common.field.have" })
                                                    : formatMessage({ id: "common.field.has" }),
                                            }
                                        )}
                                    </a>
                                </div>
                            )
                    )}
                </div>
            ) : (
                ""
            )}
        </>
    );
};

export default TotalAIOrderNeededContainer;
